import { useNavigate } from "react-router-dom";

import { Layout } from "../components/Layout";
import { ForgottenPasswordForm } from "../components/ForgottenPassword";

export const ForgottenPassword = () => {
  const navigate = useNavigate();

return (
  <Layout title="Colleague Portal">
    <ForgottenPasswordForm onSuccess={() => navigate("/auth/login")} />
  </Layout>
);
};
